import script from "./ApprovalPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApprovalPage.vue?vue&type=script&setup=true&lang=ts"

import "./ApprovalPage.vue?vue&type=style&index=0&id=c5019fc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5019fc4"]])

export default __exports__